import { render, staticRenderFns } from "./AbsenceList.vue?vue&type=template&id=01a7203f"
import script from "./AbsenceList.vue?vue&type=script&lang=ts"
export * from "./AbsenceList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports